import styled from 'styled-components'

export const SocialCard = styled.a`
    width: 44px;
    height: 44px;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.colors.footerPrimary};
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`

export const Icon = styled.img`
    width: 60%;
    height: 60%;
    object-fit: contain;
`
